import React from 'react';

function fmtSavedAddr(a) {
  return [a.address, a.city, a.state, a.zip_code, a.country].filter(Boolean).join(', ');
}

const ADDR_TYPE_LABEL = {
  delivery: 'Delivery', branch: 'Branch', warehouse: 'Warehouse',
  registered: 'Registered', billing: 'Billing', shipping: 'Shipping', other: 'Other',
};

export function AddressField({ label, value, onChange, savedAddresses, rightAction }) {
  const [open, setOpen] = React.useState(false);
  const ref = React.useRef(null);
  React.useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);
  return (
    <div className="form-group" style={{ flex: 1 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
        <label className="form-label" style={{ marginBottom: 0 }}>{label}</label>
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }}>
          {rightAction}
          {savedAddresses.length > 0 && (
            <div ref={ref} style={{ position: 'relative' }}>
              <button type="button" className="btn btn-ghost btn-sm"
                style={{ fontSize: '0.72rem', padding: '2px 8px', display: 'flex', alignItems: 'center', gap: 4 }}
                onClick={() => setOpen(o => !o)}>
                <svg width="11" height="11" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                  <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/>
                  <circle cx="12" cy="9" r="2.5"/>
                </svg>
                {savedAddresses.length} saved
              </button>
              {open && (
                <div style={{
                  position: 'absolute', top: '100%', right: 0, zIndex: 200,
                  background: 'var(--surface)', border: '1px solid var(--border)',
                  borderRadius: 8, boxShadow: '0 4px 20px rgba(0,0,0,0.12)',
                  minWidth: 280, maxHeight: 240, overflowY: 'auto', padding: 6,
                }}>
                  {savedAddresses.map(a => (
                    <button key={a.id} type="button"
                      onClick={() => { onChange(fmtSavedAddr(a)); setOpen(false); }}
                      style={{ width: '100%', textAlign: 'left', background: 'none', border: 'none', cursor: 'pointer', padding: '7px 10px', borderRadius: 6, marginBottom: 2 }}
                      onMouseEnter={e => e.currentTarget.style.background = 'var(--surface-2)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'none'}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, marginBottom: 2 }}>
                        <span style={{ fontWeight: 600, fontSize: '0.82rem', color: 'var(--text-primary)' }}>{a.label}</span>
                        {a.address_type && a.address_type !== 'other' && (
                          <span style={{ fontSize: '0.68rem', padding: '1px 6px', borderRadius: 8, background: 'var(--primary-lighter)', color: 'var(--primary)', fontWeight: 600 }}>
                            {ADDR_TYPE_LABEL[a.address_type] || a.address_type}
                          </span>
                        )}
                      </div>
                      <div style={{ fontSize: '0.76rem', color: 'var(--text-muted)', lineHeight: 1.4 }}>{fmtSavedAddr(a) || '—'}</div>
                    </button>
                  ))}
                </div>
              )}
            </div>
          )}
        </div>
      </div>
      <textarea className="form-control" rows={3} placeholder="Street, City, State, ZIP, Country"
        value={value} onChange={e => onChange(e.target.value)}
        style={{ resize: 'vertical', minHeight: 72, fontFamily: 'inherit' }} />
    </div>
  );
}

export function AddressFields({ billingValue, shippingValue, savedAddresses, onBillingChange, onShippingChange, onSameAsBilling }) {
  return (
    <div className="form-row" style={{ alignItems: 'flex-start' }}>
      <AddressField label="Billing Address" value={billingValue} onChange={onBillingChange} savedAddresses={savedAddresses} />
      <AddressField label="Shipping Address" value={shippingValue} onChange={onShippingChange} savedAddresses={savedAddresses}
        rightAction={
          <button type="button" className="btn btn-ghost btn-sm" style={{ fontSize: '0.72rem', padding: '2px 8px' }}
            onClick={onSameAsBilling}>
            Same as billing
          </button>
        }
      />
    </div>
  );
}
